import { translate } from '@/core/localization/translate';
export const {
  decrementLabel,
  incrementLabel
} = translate({
  "incrementLabel": "Increase quantity",
  "decrementLabel": "Decrease quantity"
});
export const {
  surfaceInputText,
  surfaceInputSubmit,
  surfaceInputDisclaimer
} = translate({
  "surfaceInputText": "Need help ? Enter the m\xB2 you need",
  "surfaceInputSubmit": "Calculate",
  "surfaceInputDisclaimer": "Be careful, don't forget to add 5% to the surface of your room for the offcuts."
});